import {
    FETCH_TRANSACTIONS_REQUEST,
    FETCH_TRANSACTIONS_SUCCESS,
    FETCH_TRANSACTIONS_ERROR,
    HIDE_TRANSACTION_LOADER,
    SHOW_TRANSACTION_LOADER,
    GENERATE_REPORT_REQUEST,
    GENERATE_REPORT_SUCCESS,
    GENERATE_REPORT_ERROR,
    GET_ACTIVE_REPORT_REQUEST,
    GET_ACTIVE_REPORT_SUCCESS,
    GET_ACTIVE_REPORT_ERROR,
    DOWNLOAD_REPORT_REQUEST,
    DOWNLOAD_REPORT_SUCCESS,
    DOWNLOAD_REPORT_ERROR,
    FETCH_TRANSACTIONS_STATUS_REQUEST,
    FETCH_TRANSACTIONS_STATUS_SUCCESS,
    FETCH_TRANSACTIONS_STATUS_ERROR,
    RESET_TRANSACTION_STATE,
    GET_REFUND_TXN_REQUEST,
    GET_REFUND_TXN_SUCCESS,
    GET_REFUND_TXN_ERROR,
    RESET_REFUND_TXN,
} from './transactions.constants';

export const fetchTransactionsRequest = payload => ({
    type: FETCH_TRANSACTIONS_REQUEST,
    payload,
});

export const fetchTransactionsSuccess = payload => ({
    type: FETCH_TRANSACTIONS_SUCCESS,
    payload,
});

export const fetchTransactionsError = payload => ({
    type: FETCH_TRANSACTIONS_ERROR,
    payload,
});

export const fetchTransactionsStatusRequest = payload => ({
    type: FETCH_TRANSACTIONS_STATUS_REQUEST,
    payload,
});

export const fetchTransactionsStatusSuccess = payload => ({
    type: FETCH_TRANSACTIONS_STATUS_SUCCESS,
    payload,
});

export const fetchTransactionsStatusError = payload => ({
    type: FETCH_TRANSACTIONS_STATUS_ERROR,
    payload,
});

export const generateReportRequest = payload => ({
    type: GENERATE_REPORT_REQUEST,
    payload,
});

export const generateReportSuccess = payload => ({
    type: GENERATE_REPORT_SUCCESS,
    payload,
});

export const generateReportError = payload => ({
    type: GENERATE_REPORT_ERROR,
    payload,
});

export const getActiveReportRequest = payload => ({
    type: GET_ACTIVE_REPORT_REQUEST,
    hideLoader: payload.hideLoader,
    payload,
});

export const getActiveReportSuccess = payload => ({
    type: GET_ACTIVE_REPORT_SUCCESS,
    payload,
});

export const getActiveReportError = payload => ({
    type: GET_ACTIVE_REPORT_ERROR,
    payload,
});

export const getRefundTxnRequest = payload => ({
    type: GET_REFUND_TXN_REQUEST,
    payload,
});

export const getRefundTxnSuccess = payload => ({
    type: GET_REFUND_TXN_SUCCESS,
    payload,
});

export const getRefundTxnError = payload => ({
    type: GET_REFUND_TXN_ERROR,
    payload,
});

export const resetRefunTxn = () => ({
    type: RESET_REFUND_TXN,
});

export const downloadReportRequest = payload => ({
    type: DOWNLOAD_REPORT_REQUEST,
    payload,
});

export const downloadReportSuccess = payload => ({
    type: DOWNLOAD_REPORT_SUCCESS,
    payload,
});

export const downloadReportError = payload => ({
    type: DOWNLOAD_REPORT_ERROR,
    payload,
});

export const showLoader = () => ({ type: SHOW_TRANSACTION_LOADER });

export const hideLoader = () => ({ type: HIDE_TRANSACTION_LOADER });

export const resetTxnState = () => ({ type: RESET_TRANSACTION_STATE });
